import { footerColumns, SITE_NAME } from "@/mocks/manga";

export default function Footer() {
  const scrollTo = (id: string) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer className="w-full bg-primary-900 text-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 text-foreground-950">
                <i className="ri-heart-3-fill text-lg" />
              </span>
              <span className="font-heading text-xl text-background-50">{SITE_NAME}</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-100">
              专注《甜蜜惩罚》剧情向梳理，主线、角色、分话与结局线索持续更新，
              陪每一位读者理清脉络、追更不迷路。
            </p>
            <div className="mt-5 flex gap-3">
              {["ri-mail-line", "ri-qq-line", "ri-wechat-line", "ri-weibo-line"].map((icon) => (
                <a
                  key={icon}
                  href="#contact"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollTo("contact");
                  }}
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-primary-100/40 text-primary-100 transition-colors hover:border-accent-400 hover:text-accent-300"
                  aria-label="联系我们"
                >
                  <i className={icon} />
                </a>
              ))}
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-base text-background-50">{col.title}</h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {col.links.map((l) => (
                  <li key={l.id}>
                    <a
                      href={`#${l.id}`}
                      onClick={(e) => {
                        e.preventDefault();
                        scrollTo(l.id);
                      }}
                      className="text-sm text-primary-100 transition-colors hover:text-accent-300"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-primary-100/20 pt-6 sm:flex-row">
          <p className="text-sm text-primary-100">
            © {new Date().getFullYear()} {SITE_NAME} · 本站为剧情向整理站点
          </p>
          <button
            type="button"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap text-sm text-primary-100 transition-colors hover:text-accent-300"
          >
            <i className="ri-arrow-up-line" />
            回到顶部
          </button>
        </div>
      </div>
    </footer>
  );
}